module.exports = __webpack_public_path__ + "img/Cypress 1440x480 v2.85d88627.png";